import React from "react";
import "./styles.scss";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import Certificat from "../../assets/Certificat.pdf";

const Footer: React.FC = () => {
  return (
    <section className="footer">
      <div className="footer-container">
        <div className="footer-container-main-cell">
          <h3>Natelco – Les Ateliers de la Connaissance</h3>
          <p>Formation, Bilan de compétences, Coaching, Conseils</p>
          <p>RCS Paris : B 818585077 00014</p>
          <p>Numéro d’agrément : 11 75 54 55 475</p>
          <p>
            Organisme de formation certifié Qualiopi pour les actions de
            formation et de bilan de compétences
          </p>
          <p>
            Certification Qualiopi délivrée par l’organisme certificateur PRONEO
            CERTIFICATION
          </p>
          <p>
            Ce certificat est valable* du 24/10/2023 au 23/10/2026 Date
            originale du cycle de certification en cours : 24/10/2023 Certificat
            n° F2632-1-I (*sous réserve d'une surveillance entre le 14ème et
            22ème mois du cycle de 3 ans)
          </p>
          <p>
            La certification qualité a été délivrée au titre des actions de
            formation et des bilans de compétences.
          </p>
        </div>
        <div className="footer-container-cell">
          <h3>Contact</h3>
          <p>
            <a className="footer-link" href="mailto:contact@natelco.fr">
              contact@natelco.fr
            </a>
          </p>
          <p>
            <a className="footer-link" href="tel:0660478556">
              +33 6 60 47 85 56
            </a>
          </p>
          <p>
            <Link to="/mentions-legales" className="footer-link">
              Mentions Légales
            </Link>
          </p>
          <p>
            <a
              className="footer-link"
              href={Certificat}
              download="Certificat.pdf"
            >
              Certificat Qualiopi
            </a>
          </p>
        </div>
        <div className="footer-container-cell">
          <h3>Nous rejoindre</h3>
          <p>
            <a className="footer-link" href="mailto:contact@natelco.fr">
              contact@natelco.fr
            </a>
          </p>
          <p>Dernière mise à jour : Juillet 2026</p>
        </div>
      </div>
      <div className="footer-copyright">
        <h3>Copyright © {dayjs().year()} Natelco. All Rights Reserved.</h3>
      </div>
    </section>
  );
};

export default Footer;
